module.exports = __webpack_public_path__ + "parent_departments_Dark_teal.ec291ed80e14eb06738f.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/parent_departments_Dark_teal.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/parent_departments_Dark_teal.svg
// module chunks = styles